export default [
    {
        path: '/corpfeedback/addfeedback',
        meta: {
            title: '建议反馈',
        },
        component: r => require.ensure([], () => r(require(`./addfeedback.vue`)), `/corpfeedback`),
    },
    {
        path: '/corpfeedback/feedbackresult',
        meta: {
            title: '反馈',
        },
        component: r => require.ensure([], () => r(require(`./feedback_result.vue`)), `/corpfeedback`),
    }
]


// WEBPACK FOOTER //
// ./src/views/CorpFeedback/router.js